/**
 * Magnimoo Blog Enhancements
 * Transforms plain article HTML into interactive, engaging content
 */
(function() {
  'use strict';

  var content = document.querySelector('.article-template__content');
  if (!content) return;

  /* --- Reading Progress Bar --- */
  function initProgressBar() {
    var bar = document.createElement('div');
    bar.className = 'blog-progress-bar';
    document.body.appendChild(bar);

    var article = document.querySelector('.article-template');
    if (!article) return;

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var rect = article.getBoundingClientRect();
          var articleTop = rect.top + window.pageYOffset;
          var articleHeight = article.offsetHeight;
          var windowHeight = window.innerHeight;
          var scrolled = window.pageYOffset - articleTop + windowHeight * 0.3;
          var progress = Math.max(0, Math.min(100, (scrolled / articleHeight) * 100));
          bar.style.width = progress + '%';
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* --- Table of Contents --- */
  function initTOC() {
    var headings = content.querySelectorAll('h2');
    if (headings.length < 3) return;

    var toc = document.createElement('nav');
    toc.className = 'blog-toc blog-reveal';
    toc.setAttribute('aria-label', 'Table of contents');

    var title = document.createElement('div');
    title.className = 'blog-toc__title';

    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    var path = document.createElementNS(svgNS, 'path');
    path.setAttribute('d', 'M4 6h16M4 12h16M4 18h7');
    svg.appendChild(path);
    title.appendChild(svg);

    var titleText = document.createTextNode(' In This Article');
    title.appendChild(titleText);
    toc.appendChild(title);

    var list = document.createElement('ol');
    list.className = 'blog-toc__list';

    headings.forEach(function(h, i) {
      var id = 'section-' + i;
      h.id = id;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent;
      a.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.getElementById(id);
        if (target) {
          var offset = target.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: offset, behavior: 'smooth' });
        }
      });
      li.appendChild(a);
      list.appendChild(li);
    });

    toc.appendChild(list);

    var firstP = content.querySelector('p');
    if (firstP && firstP.nextSibling) {
      firstP.parentNode.insertBefore(toc, firstP.nextSibling);
    } else {
      content.insertBefore(toc, content.firstChild);
    }

    /* Active heading tracking */
    var tocLinks = list.querySelectorAll('a');
    var headingOffsets = [];

    function updateOffsets() {
      headingOffsets = [];
      headings.forEach(function(h, i) {
        headingOffsets.push({ id: i, top: h.getBoundingClientRect().top + window.pageYOffset });
      });
    }

    function updateActive() {
      var scrollPos = window.pageYOffset + 120;
      var activeIndex = 0;
      for (var i = headingOffsets.length - 1; i >= 0; i--) {
        if (scrollPos >= headingOffsets[i].top) {
          activeIndex = i;
          break;
        }
      }
      tocLinks.forEach(function(link, i) {
        link.classList.toggle('active', i === activeIndex);
      });
    }

    updateOffsets();
    window.addEventListener('scroll', updateActive, { passive: true });
    window.addEventListener('resize', function() { updateOffsets(); updateActive(); }, { passive: true });
    updateActive();
  }

  /* --- Wrap Tables --- */
  function enhanceTables() {
    var tables = content.querySelectorAll('table');
    tables.forEach(function(table) {
      if (table.parentNode.classList.contains('blog-table-wrap')) return;

      var wrap = document.createElement('div');
      wrap.className = 'blog-table-wrap blog-reveal';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  /* --- Stat Callouts --- */
  function enhanceStatCallouts() {
    var paragraphs = content.querySelectorAll('p');
    paragraphs.forEach(function(p) {
      var text = p.textContent.trim();
      if (/^(Quick stat|Pro tip|Note|Important|Did you know|Fun fact)/i.test(text)) {
        p.classList.add('blog-stat-callout');
        p.classList.add('blog-reveal');
      }
    });
  }

  /* --- CTA Detection --- */
  function enhanceCTAs() {
    var paragraphs = content.querySelectorAll('p');
    paragraphs.forEach(function(p) {
      var text = p.textContent.trim().toLowerCase();
      var hasLink = p.querySelector('a[href*="/products/"], a[href*="magnimoo"]');
      if (hasLink && /\b(get your|shop now|try|order|buy|ready to|make playtime)\b/i.test(text)) {
        if (!p.classList.contains('blog-stat-callout')) {
          var wrap = document.createElement('div');
          wrap.className = 'blog-cta-box blog-reveal';
          p.parentNode.insertBefore(wrap, p);
          wrap.appendChild(p);
        }
      }
    });
  }

  /* --- Scroll Reveal --- */
  function initScrollReveal() {
    var revealTargets = content.querySelectorAll('h2, h3, blockquote, .blog-table-wrap, .blog-stat-callout, .blog-cta-box, img');
    revealTargets.forEach(function(el) {
      if (!el.classList.contains('blog-reveal')) {
        el.classList.add('blog-reveal');
      }
    });

    var lists = content.querySelectorAll('ul, ol');
    lists.forEach(function(list) {
      if (list.closest('.blog-toc')) return;
      list.classList.add('blog-reveal-stagger');
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '0px 0px -60px 0px',
        threshold: 0.1
      });

      document.querySelectorAll('.blog-reveal, .blog-reveal-stagger').forEach(function(el) {
        observer.observe(el);
      });
    } else {
      document.querySelectorAll('.blog-reveal, .blog-reveal-stagger').forEach(function(el) {
        el.classList.add('is-visible');
      });
    }
  }

  /* --- Initialize --- */
  function init() {
    initProgressBar();
    enhanceTables();
    enhanceStatCallouts();
    enhanceCTAs();
    initTOC();
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
